import userAgent from 'user-agent'
import router from '@/router'

export function getExtraData () {
  const { 
    // title, 
    URL, 
    domain } = document || {}
  return {
    // sourcePageTitle: title,
    sourcePageTitle: router.currentRoute.meta.title,
    domain,
    sourcePageUrl: URL || location.href,
    userAgent: JSON.stringify(userAgent.parse(navigator.userAgent))
  }
}
